import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Basics, isSmartphone } from '../_app/cuchillo/core/Basics';
import { Maths } from '../_app/cuchillo/utils/Maths';
import BezierEasing from 'bezier-easing';


class ScrollItem__Projects extends Scroll_Item {
    _call;
    _slider;
    _current = -1;
    _total = 0;
    _visor;
    _items = [];
    _progress_offset
    easing = BezierEasing(0.69, 0.27, 0.69, 0.28);

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

       // if(!isSmartphone) {
            this.setupItems();
        
            this.onMove = () => {
              this.updateItems(this.progressInside)
            };
        //}
    }

    updateItems(progress) {
      for(let i=0; i<this._total; i++) {
        
          const partial = Maths.normalize(this._progress_offset * (i + 1), this._progress_offset * i, this.easing(progress));
          const progressItem = partial < 1 ? partial : Math.max(1 - (partial - 1), 0);
         
          this._items[i].progress = progressItem;
       
      }
    }

    setupItems() {
        const items = [... GetBy.class("__item", this.item)];
    
        for(let i=0; i<items.length; i++) {
            this._total = this._items.push(new ScrollItem__Projects__Item(items[i]));
        }

        this._progress_offset = 1 / this._total;
    }

    resize(w, h) {
        super.resize(w, h);
    }

    loop() {}

    dispose() {
        super.dispose();
        /*if(!isSmartphone) */ document.removeEventListener(Basics.moveEvent, this._call);
    }
}

class ScrollItem__Projects__Item {
  _progress;
  item;

  set progress(p) {
    this.item.style.setProperty('--progress-item', p);
  }

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__item) {
    this.item = __item;
  }
}

Scroll._registerClass('BidllboardServices', ScrollItem__Projects);
